export enum HealthType {
  InPatientBenefit = 'BNF01',
  OutPatientBenefit = 'BNF02',
  DentalBenefit = 'BNF03',
  MaternityCare = 'BNF04'
}
